<template>
  <ul :class="['sites', theme]">
    <li
      class="site"
      v-for="logo in logoOptions"
      :key="logo.id"
      @click="checkSite(logo)"
      :class="['logo', { on: selectedSiteIds.includes(logo.id) }]"
    >
      <i class="iconfont icon-gouxuan"></i>
      <img :src="`//bar.xkw.com${logo.filePath}`" :alt="logo.logoName" />
    </li>
  </ul>
</template>
<script>
export default {
  name: "siteChoices",
  props: {
    theme: {
      type: String,
      default: "",
    },
    selectedSiteIds: {
      type: Array,
      default: () => [],
    },
    logoOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  async mounted() {},
  methods: {
    checkSite(item) {
      this.$emit("pickSite", item.id);
      // this.$set(item, "isChecked", !item.isChecked);
    },
  },
};
</script>
<style lang="scss" scoped>
.sites .logo {
  position: relative;
  margin-bottom: 10px;
  padding: 10px 0 10px 26px;
  height: 50px;
  border-radius: 8px;
  background: #f4f5f9;
  cursor: pointer;
  img {
    display: block;
    height: 30px;
  }
  .iconfont {
    position: absolute;
    left: 6px;
    width: 14px;
    height: 14px;
    font-size: 10px;
    color: #fff;
    top: 50%;
    transform: translate(0, -50%);
    background: #3f69f9;
    border-radius: 100%;
    opacity: 0;
    &:before {
      position: absolute;
      top: 1px;
      left: 1px;
      transform: scale(0.9);
    }
  }
  &.on,
  &:hover {
    outline: 1px solid #3f69f9;
  }
  &.on {
    .iconfont {
      opacity: 1;
    }
  }
}
.dark {
  &.sites .logo {
    border-radius: 8px;
    padding-left: 46px;
    outline: 1px solid rgba(148, 131, 255, 0.3);
    background: #242931;
    .iconfont {
      left: 16px;
      width: 20px;
      height: 20px;
      font-size: 8px;
      color: #242931;
      border: 1px solid #6d7278;
      opacity: 1;
      background: transparent;
      &:before {
        top: 6px;
        left: 5px;
        opacity: 0;
      }
    }
    &.on {
      outline: 1px solid #8569d9;
      background: linear-gradient(295deg, rgba(122, 85, 232, 0.2) -2.91%, rgba(23, 143, 255, 0.2) 89.83%);
      .iconfont {
        background: linear-gradient(295deg, #8569d9 0%, #4da9ff 100%);
        border: none;
        &::before {
          opacity: 1;
        }
      }
    }
    &:hover {
      outline: 1px solid #8569d9;
      background: linear-gradient(295deg, rgba(122, 85, 232, 0.2) -2.91%, rgba(23, 143, 255, 0.2) 89.83%);
    }
  }
}
</style>
